import { createSlice } from '@reduxjs/toolkit';
import {
  getCatalogue,
  getCatalogueByMetadataId,
  connectCatalogue,
  disconnectCatalogue,
  getProducts,
  createProduct,
} from './product-action';
import { DEFAULT_PRODUCT_STATE } from '../../../constants/defaultStates/product';

import {
  removeDeleteData,
  updateProductTable,
  getUnselectedProducts,
  isProductInList,
} from '../../../utils/tableUtils';

const productSliceWCA = createSlice({
  name: 'product',
  initialState: DEFAULT_PRODUCT_STATE,
  reducers: {
    resetProductState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
    resetCatalogueState: (state) => {
      state.catalogLoading = false;
      state.connectLoading = false;
      state.disconnectLoading = false;
      state.catalogFetching = false;

      state.error = null;
      state.success = false;
    },

    changeMode(state, action) {
      state.mode = action.payload;
    },

    resetMode(state) {
      state.mode = null;
    },
    setproduct(state, action) {
      if (state.productData.length < state.limit) {
        state.productData = [action.payload, ...state.productData];
      }
      state.totalProductCount += 1;
    },
    changeSelectedProduct(state, action) {
      // console.log(action.payload)
      state.selectedProduct = action.payload;
    },

    resetSelectedProduct(state) {
      state.selectedProduct = null;
    },

    changePage(state, action) {
      state.page = action.payload;
    },
    changelimit(state, action) {
      state.limit = action.payload;
    },
    changeSelectedProductsList(state, action) {
      // console.log(action.payload)
      state.selectedProductsList = action.payload;
    },
    changeSelectedProductBlist(state, action) {
      // console.log(action.payload)
      state.selectedProductBlist = action.payload;
    },
    resetSelectedProductBlist(state) {
      state.selectedProductBlist = [];
    },
    updateSelectedProductsList(state, action) {
      state.selectedProductsList = action.payload.selectedProducts;
      console.log('state.selectedProductsList', state.selectedProductsList);
    },
    updateSelectedProductsBList(state, action) {
      const { selectedProducts, currProducts } = action.payload;
      if (!state.selectedProductBlist?.length) {
        state.selectedProductBlist = selectedProducts;
      } else {
        const newItems = selectedProducts.filter((product) => {
          if (!isProductInList(state.selectedProductBlist, product)) return product;
        });
        const unselectedProducts = getUnselectedProducts(currProducts, selectedProducts);

        const onlySelectedItems = state.selectedProductBlist.filter((product) => {
          if (!isProductInList(unselectedProducts, product)) return product;
        });
        state.selectedProductBlist = [...onlySelectedItems, ...newItems];
      }
    },

    resetSelectedProductsList(state) {
      state.selectedProductsList = [];
    },
    resetAll(state) {
      state.selectedProductsList = DEFAULT_PRODUCT_STATE.selectedProductsList;
      state.productData = DEFAULT_PRODUCT_STATE.productData;
      state.page = DEFAULT_PRODUCT_STATE.page;
      state.limit = DEFAULT_PRODUCT_STATE.limit;
      state.selectedProduct = DEFAULT_PRODUCT_STATE.selectedProduct;
      state.mode = DEFAULT_PRODUCT_STATE.mode;
    },
    removeProductFromProductsBList(state, action) {
      let removeProductSKUCode = action.payload;

      let currSelectedProductsForBroadcast = [...state.selectedProductBlist];
      state.selectedProductBlist = currSelectedProductsForBroadcast.filter(
        (prod) => prod.SKUCode != removeProductSKUCode,
      );
    },
  },
  extraReducers: (builder) => {
    builder

      // 🔹 GET CATALOGUE
      .addCase(getCatalogue.pending, (state) => {
        state.catalogFetching = true;
      })
      .addCase(getCatalogue.fulfilled, (state, action) => {
        state.catalogFetching = false;
        state.catalogue = action.payload;
      })
      .addCase(getCatalogue.rejected, (state, action) => {
        state.catalogFetching = false;
        state.error = action.payload;
      })

      // 🔹 GET CATALOGUE BY METADATA
      .addCase(getCatalogueByMetadataId.pending, (state) => {
        state.catalogLoading = true;
      })
      .addCase(getCatalogueByMetadataId.fulfilled, (state, action) => {
        state.catalogLoading = false;
        state.catalogueByMetadata = action.payload;
      })
      .addCase(getCatalogueByMetadataId.rejected, (state, action) => {
        state.catalogLoading = false;
        state.error = action.payload;
      })

      // 🔹 CONNECT CATALOGUE
      .addCase(connectCatalogue.pending, (state) => {
        state.connectLoading = true;
      })
      .addCase(connectCatalogue.fulfilled, (state) => {
        state.connectLoading = false;
        state.success = true;
      })
      .addCase(connectCatalogue.rejected, (state, action) => {
        state.connectLoading = false;
        state.error = action.payload;
      })

      // 🔹 DISCONNECT CATALOGUE
      .addCase(disconnectCatalogue.pending, (state) => {
        state.disconnectLoading = true;
      })
      .addCase(disconnectCatalogue.fulfilled, (state) => {
        state.disconnectLoading = false;
        state.success = true;
      })
      .addCase(disconnectCatalogue.rejected, (state, action) => {
        state.disconnectLoading = false;
        state.error = action.payload;
      })

      // 🔹 GET PRODUCTS
      .addCase(getProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.loading = false;

        const { rows, count, cursor } = action.payload;

        state.totalProductCount = count;

        state.cursor = cursor;

        state.productData = rows;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 🔹 CREATE PRODUCT
      .addCase(createProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.productData.unshift(action.payload);
        state.success = true;
      })
      .addCase(createProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  resetProductState,
  resetCatalogueState,
  changeMode,
  changeSelectedProduct,
  resetSelectedProduct,
  resetMode,
  changePage,
  setproduct,
  changeSelectedProductBlist,
  updateSelectedProductsBList,
  updateSelectedProductsList,
  changeSelectedProductsList,
  resetSelectedProductsList,
  resetSelectedProductBlist,
  changelimit,
  resetAll,
  removeProductFromProductsBList,
} = productSliceWCA.actions;
export default productSliceWCA.reducer;
